export default class Video {
	constructor(config) {
		this.el = config.el || document.querySelector(".video");
		this.video = this.el.querySelector("video");
		this.playButton = this.el.querySelector(".video__button-play");
		this.pauseButton = this.el.querySelector(".video__button-pause");
		this.videoIsPlaying = false;
		this.videoPlayingClass = "video--playing";
		this.init();
	}
	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		const self = this;
		this.video.addEventListener("click", function() {
			self.toggleVideo();
		});
		this.playButton.addEventListener("click", e => {
			this.play();
		});
		this.pauseButton.addEventListener("click", e => {
			this.pause();
		});
	}
	toggleVideo() {
		if (this.videoIsPlaying) {
			this.pause();
		} else {
			this.play();
		}
	}
	play(i) {
		this.video.play();
		this.videoIsPlaying = true;
		this.el.classList.add(this.videoPlayingClass);
	}
	pause(e) {
		this.videoIsPlaying = false;
		this.video.pause();
		this.el.classList.remove(this.videoPlayingClass);
	}
}
